__turbopack_context__.v({
  "account": "consent-module__DnpHmW__account",
  "additionalAccess": "consent-module__DnpHmW__additionalAccess",
  "authForm": "consent-module__DnpHmW__authForm",
  "avatar": "consent-module__DnpHmW__avatar",
  "card": "consent-module__DnpHmW__card",
  "details": "consent-module__DnpHmW__details",
  "error": "consent-module__DnpHmW__error",
  "identity": "consent-module__DnpHmW__identity",
  "intro": "consent-module__DnpHmW__intro",
  "legal": "consent-module__DnpHmW__legal",
  "nextStep": "consent-module__DnpHmW__nextStep",
  "owl": "consent-module__DnpHmW__owl",
  "pageRoot": "consent-module__DnpHmW__pageRoot",
  "permissions": "consent-module__DnpHmW__permissions",
  "primary": "consent-module__DnpHmW__primary",
  "reassurance": "consent-module__DnpHmW__reassurance",
  "scope": "consent-module__DnpHmW__scope",
  "secondary": "consent-module__DnpHmW__secondary",
  "signedIn": "consent-module__DnpHmW__signedIn",
  "spin": "consent-module__DnpHmW__spin",
  "spinning": "consent-module__DnpHmW__spinning",
});
